import React from "react";
import { Box, Container, Typography, Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function TrainingProgram() {
  const navigate = useNavigate();

  return (
    <>
      <head>
        <title>Industry Training Program – Arocoiris Technology</title>
        <meta
          name="description"
          content="Join Arocoiris Technology’s Industry Training & Project Experience Program for 3rd and 4th year students."
        />
        <meta property="og:title" content="Industry Training Program" />
        <meta
          property="og:description"
          content="Skill‑building, real‑world projects, and mentorship for engineering students."
        />
        <meta
          property="og:url"
          content="https://www.arocoiristechnology.com/services/training-program"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.arocoiristechnology.com/og-training.png"
        />

        {/* Structured Data */}
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org/",
  "@type": "Course",
  "name": "Industry Training & Project Experience Program",
  "description": "A structured training program for engineering students to gain real‑world project experience.",
  "provider": {
    "@type": "Organization",
    "name": "Arocoiris Technology",
    "sameAs": "https://www.arocoiristechnology.com/"
  }
}
`}
        </script>
      </head>

      <Box sx={{ py: 10, backgroundColor: "#0A192F", color: "white" }}>
        <Container maxWidth="lg">

          {/* HERO */}
          <Typography variant="h3" fontWeight={700} sx={{ mb: 2 }}>
            Industry Training & Project Experience Program
          </Typography>

          <Typography
            variant="h6"
            sx={{ color: "#B0BEC5", maxWidth: 700, mb: 6 }}
          >
            A structured, mentor‑led program designed for 3rd and 4th year
            engineering students to gain real‑world project exposure, hands‑on
            learning, and industry‑ready skills. This is a <b>training program</b>,
            not an internship or employment opportunity.
          </Typography>

          {/* PROGRAM MODULES */}
          <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
            Program Tracks
          </Typography>

          <Grid container spacing={4}>
            {[
              {
                title: "Full‑Stack Development",
                desc: "Learn MERN stack, APIs, cloud deployment, and build production‑grade apps.",
                duration: "8 Weeks"
              },
              {
                title: "AI/ML Foundations",
                desc: "Hands‑on ML models, Python, data pipelines, and real‑world AI use‑cases.",
                duration: "10 Weeks"
              },
              {
                title: "Software Testing (SDET)",
                desc: "Automation, QA pipelines, Cypress, Selenium, and CI/CD  and project handson.",
                duration: "8 Weeks"
              },
              {
                title: "Backend Development",
                desc: "Learn to build scalable backend system using Java,Spring Boot, Microservices",
                duration: "8 Weeks"
              }
            ].map((track, i) => (
              <Grid item xs={12} sm={6} md={3} key={i}>
                <Box
                  sx={{
                    p: 3,
                    height: "100%",
                    borderRadius: 3,
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  }}
                >
                  <Box>
                    <Typography variant="h6" fontWeight={600}>
                      {track.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: "#B0BEC5", mt: 1 }}
                    >
                      {track.desc}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: "#4CAF50", mt: 2, fontWeight: 600 }}
                    >
                      Duration: {track.duration}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: "#FFEB3B", mt: 1, fontWeight: 600 }}
                    >
                      Contact Sales for Fee Details
                    </Typography>
                  </Box>

                  <Button
                    variant="outlined"
                    color="success"
                    sx={{ mt: 3 }}
                    component="a"
                    href="mailto:sales@arocoiristechnology.com"
                  >
                    Contact Sales
                  </Button>
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* REGISTER BUTTON */}
          <Box sx={{ textAlign: "center", mt: 6 }}>
            <Button
              variant="contained"
              color="success"
              size="large"
              sx={{ px: 5, py: 1.5, borderRadius: 2 }}
              onClick={() => navigate("/training/TrainingRegistration")}
            >
              Register Now
            </Button>
          </Box>

          {/* FOOTER NOTE */}
          <Typography variant="body2" sx={{ mt: 4, color: "#B0BEC5" }}>
            This is a <b>training & skill‑development program</b>. It does not
            guarantee employment or internship placement. For queries, contact{" "}
            <span style={{ color: "#4CAF50", fontWeight: 600 }}>
              sales@arocoiristechnology.com
            </span>.
          </Typography>
        </Container>
      </Box>
    </>
  );
}